import { useState, useEffect } from 'react';
import { Grid, Typography, Button, Radio, CircularProgress, Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setPoDashboardPoList, setSelectedPoId, updatePharmaorderObj, updatePoObj, getPoObj } from 'store/slice/PharmaSlice';
import { attachPoAPI } from 'api/OmsOrdermgmtWebServices';
import FieldView from 'core/components/layout/FieldView';

export default function PoSelectionMgmtPoList() {
    const dispatch = useDispatch();
    const [apiInProgress, setApiInProgress] = useState(false);
    const { poList, poDashboard } = useSelector((state) => state.pharmaslice);
    const { pharmaorderObj } = useSelector((state) => state.pharmaslice.pharmaorderDashboard);
    const [selectedPOidLocal, setSelectedPOidLocal] = useState('');
    const [msg, setMsg] = useState('');
    const [msgType, setMsgType] = useState(1);
    const [poPathForClickedPO, setPoPathForClickedPO] = useState('');
    const [initialPO, setInitialPO] = useState('');

    const handlePOchange = (event) => {
        setMsg('');
        setSelectedPOidLocal(event.target.value);
        dispatch(setSelectedPoId(event.target.value))
    };
    useEffect(() => {
        dispatch(setPoDashboardPoList(
            poList.filter(poObj => poObj.partyid === pharmaorderObj.partyid)
        ))
        setSelectedPOidLocal(pharmaorderObj.poid);
        setInitialPO()
    }, [])
    useEffect(() => {
        if (poDashboard.poObj.popath === '' || poDashboard.poObj.popath === undefined) {
            setMsgType(0);
            setMsg('Cannot attach this PO because PO file is not uploaded, yet. Upload PO file to attach this PO.');
        } 
        // else if (selectedPOidLocal == pharmaorderObj.poid) {
        //     setMsgType(1);
        //     setMsg('PO is already attached.');
        // } 
        // else {
        //     setMsg('');
        // }
        setPoPathForClickedPO(poDashboard.poObj.popath);

    }, [poDashboard.poList, poDashboard.poObj])

    const attachPoSuccessCallBack = (response) => {
        setApiInProgress(false);
        setMsgType(1);
        setMsg("PO is successfully attached to order !!!");
        dispatch(updatePharmaorderObj(response.pharmaorderInfo));

        response.poInfoList.list.map((poObj) => {
            dispatch(updatePoObj(poObj));
        })


    }
    const attachPoFailureCallBack = (error) => {
        console.log('Error]attachPoFailureCallBack] =>' + (error));
        setApiInProgress(false);
        setMsgType(0);
        setMsg(error);
    }
    const attachPO = () => {
        setApiInProgress(true);

        attachPoAPI({
            "orderId": pharmaorderObj.orderid,
            "poId": selectedPOidLocal
        }, attachPoSuccessCallBack, attachPoFailureCallBack);
    }
    return (
<>
    <Box lg={12} sx={{ flexGrow: 1 }}>
        <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: {xs:180,lg:300} }}>
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
            >
                {poDashboard.poList.map((poObj) => {
                    return (
                        <>
                            <Grid item lg={2} xs={2} >
                                <Radio
                                    checked={selectedPOidLocal == poObj.id}
                                    onChange={handlePOchange}
                                    value={poObj.id}
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'A' }}
                                    sx={{ backgroundColor: 'white' }}
                                />
                            </Grid>
                            <Grid item lg={4} xs={4}><FieldView label="PO Date" value={poObj.podate !== undefined ? poObj.podate.split('T')[0] : 'NOT KNONWN'} /></Grid>
                            <Grid item lg={3} xs={3}><FieldView label="PO Value" value={poObj.povalue !== undefined ? poObj.povalue : 'NOT KNONWN'} /></Grid>
                            <Grid item lg={3} xs={3}><FieldView label="Order" value={poObj.ordervalue !== undefined ? poObj.ordervalue : 'NOT KNONWN'} /></Grid>
                        </>
                    )
                })}
            </Grid>
        </Grid>
    </Box>
    <Grid >
        &nbsp;
    </Grid>
    <Grid xs={12} sx={{ textAlign: 'center' }} padding={1}>
        <Typography color={msgType ? 'green' : 'red'} sx={{}}>{msg}</Typography>
    </Grid>
    
    <Grid container direction="column" justifyContent="center" alignItems="center">
        {apiInProgress ?
            <CircularProgress /> :
            <Button variant="outlined" disabled={selectedPOidLocal == '' || selectedPOidLocal == pharmaorderObj.poid || poPathForClickedPO == '' ? true : false} onClick={attachPO}>Attach to Order</Button>
        }
    </Grid>
</>

    )
}